export enum RegisterStep
{
  NONE,
  PHONE_CONFIRM,
  INVITE_FLEET,
  EDIT_DRIVER_DETAILS,
}

export interface RegisterStage {
  userId: number | null;
  step: RegisterStep | null;
}
